<template>
    <div class="page-container">
        <van-nav-bar class="buying-navbar" title="充值完成" fixed v-if="os != 'mini'" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "rechargeSuccess",
    data: () => ({
    }),
    beforeMount() {
        if(this.os === "mini") {
            wx.miniProgram.reLaunch({
                url: "/pages/index/index?current=2"
            });
        } else {
            this.$router.replace({ path: "/user" });
        }
    },
    computed: {
        ...mapGetters(["os"])
    },
};
</script>

<style scoped lang="less">
.page-container {
    height: 100%;
    background: #fff;
}

.van-cell__title {
    color: @gray-dark;
}
.van-cell__value {
    color: @dark;
}
</style>
